import { createContext } from "react";

export const sidebarContext = createContext({})